import { render, staticRenderFns } from "./TrainingComments.vue?vue&type=template&id=08788aee&scoped=true"
import script from "./TrainingComments.vue?vue&type=script&lang=js"
export * from "./TrainingComments.vue?vue&type=script&lang=js"
import style0 from "./TrainingComments.vue?vue&type=style&index=0&id=08788aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08788aee",
  null
  
)

export default component.exports